function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.5 0h24v24H.5V0z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#task_svg__a)",
  fill: "#787B86"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.379 3.902c0-.554.524-1.003 1.17-1.003h3.901c.646 0 1.17.45 1.17 1.003v.669c0 .553-.524 1.003-1.17 1.003h-3.9c-.647 0-1.171-.45-1.171-1.003V3.9z",
  fillOpacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M9 5.095c0 .621.588 1.125 1.313 1.125h4.374c.725 0 1.313-.504 1.313-1.125V4.78h.056c1.933.01 2.98.096 3.663.779.781.781.781 2.038.781 4.553v5.334c0 2.515 0 3.771-.781 4.553-.78.78-2.039.78-4.552.78H9.833c-2.514 0-3.771 0-4.552-.78-.781-.781-.781-2.038-.781-4.553v-5.334c0-2.515 0-3.772.781-4.553.683-.683 1.73-.769 3.663-.78H9v.316zm6.812 5.401a.713.713 0 00-.99-.033l-3.52 3.202-1.12-1.02a.713.713 0 00-.685-.158.674.674 0 00-.27 1.155l1.6 1.454a.712.712 0 00.953 0l3.998-3.636a.67.67 0 00.034-.964z"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "task_svg__clip0_484_5020"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(.5)",
  d: "M0 0h24v24H0z"
})));

var SvgTask = function SvgTask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#task_svg__clip0_484_5020)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "task_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _ref), _ref2), _ref3);
};

export default SvgTask;